export class Snippet {
}


export class AddSnippet {
  id: string;
  title: string;
  description: string;
  content: string;
}

export class updateSnippet {
    id: string;
    title: string;
    description: string;
    content: string;
}

export class Id {
  id: number[];

  constructor(id: number[]) {
    this.id = id;
  }
}
  
